export class  DOState {
  number: number;
  value: number;

  constructor() {
    this.number = 0;
    this.value = 0;
  }
}

export interface DigitalOutStatus {
  DO: DOState[];
}

